import { Link, Outlet } from 'react-router-dom';
import { useTheme } from '../../hooks/useTheme';
import { useWebAuth } from '../../hooks/useWebAuth';
import { AuthControls } from '../AuthControls/AuthControls';
import './PublicLayout.scss';

const CHROME_STORE_URL = 'https://chromewebstore.google.com/detail/shareqsite/oloccejiekekblplkinfljiogebnhoao';

export function PublicLayout() {
  const { theme, toggleTheme } = useTheme();
  const { user, isAuthenticated, loading, logout } = useWebAuth();

  return (
    <div className="public-layout">
      <header className="public-layout__header">
        <div className="public-layout__header-inner">
          <Link to="/" className="public-layout__logo">
            <span className="public-layout__logo-icon">&#9670;</span>
            <span className="public-layout__logo-text"><span className="public-layout__logo-sha">sha</span><span className="public-layout__logo-re">re</span><span className="public-layout__logo-q">q</span></span>
          </Link>
          <nav className="public-layout__nav">
            <Link to="/pricing" className="public-layout__nav-link">Pricing</Link>
            <Link to="/support" className="public-layout__nav-link">Support</Link>
            <button
              className="public-layout__theme-toggle"
              onClick={toggleTheme}
              aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
            >
              {theme === 'light' ? '\u263E' : '\u2600'}
            </button>
            <AuthControls
              user={user}
              isAuthenticated={isAuthenticated}
              loading={loading}
              onLogout={logout}
            />
            <a
              href={CHROME_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="public-layout__nav-link public-layout__nav-link--cta"
            >
              Get Extension
            </a>
          </nav>
        </div>
      </header>

      <main className="public-layout__main">
        <Outlet />
      </main>

      <footer className="public-layout__footer">
        <div className="public-layout__footer-inner">
          <div className="public-layout__footer-brand">
            <span className="public-layout__logo-icon">&#9670;</span>
            <span className="public-layout__logo-text"><span className="public-layout__logo-sha">sha</span><span className="public-layout__logo-re">re</span><span className="public-layout__logo-q">q</span></span>
          </div>
          <nav className="public-layout__footer-nav">
            <Link to="/pricing">Pricing</Link>
            <Link to="/support">Support</Link>
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
          </nav>
          <p className="public-layout__footer-copy">
            &copy; {new Date().getFullYear()} ShareQ. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
